import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import {
  BodyCardSubtitle,
  BodyCardTitle,
} from "components/CardTypography/styles";

import { PaperStyles } from "components/Paper/index.style";
import ProductActivatedCard from "components/ProductActivatedCard";
import Spinner from "components/Spinner";
import { useEffect, useState } from "react";
import { AuthProps } from "services/login";
import { getProducts, ProductProps } from "services/products";
import { breakpoints } from "styles/utils";
import { AUTH_USER, getItemSessionStorage } from "utils/helpers";
import configs from "config";

const ContainerCard = styled(PaperStyles)`
  padding: 20px 0px;
  border-radius: 12px;
  margin-inline: 16px;

  @media (min-width: ${breakpoints.medium}) {
    padding: 30px 0px;
  }
`;

const HeaderCard = styled.div<{ backgroundColor?: string | undefined }>`
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  justify-content: center;
  padding: 8px 0px;

  @media (min-width: ${breakpoints.medium}) {
    padding: 20px 0px;
  }
`;

const BodyCard = styled.div`
  padding: 24px 16px;
  @media (min-width: ${breakpoints.large}) {
    padding-right: 70px;
    padding-left: 70px;
  }
`;

const WrapperInnerCard = styled(PaperStyles)`
  padding: 24px 16px;
  margin: 24px 0px !important;

  @media (min-width: ${breakpoints.medium}) {
    padding: 30px;
  }

  @media (min-width: ${breakpoints.large}) {
    padding: 50px;
  }
`;

const WrapperNoProduct = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  margin: 50px 16px;
  @media (min-width: ${breakpoints.large}) {
    justify-content: center;
    margin: 85px auto;
    max-width: 800px;
  }
`;

const Link = styled.a`
  color: #15997b;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;

function MyAccount() {
  const [loading, setLoading] = useState(false);

  const [products, setProducts] = useState<ProductProps[] | []>([]);
  const auth = getItemSessionStorage(
    `${AUTH_USER}_${configs.localStorageKey}`
  ) as AuthProps;

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      // You can await here

      const products = (await getProducts(
        auth.user_id,
        auth?.token!
      )) as ProductProps[];

      console.log("products===>", products);

      if (products.length > 0) {
        setProducts(products);
      } else {
        setProducts([]);
      }

      setLoading(false);
    }
    fetchData();
  }, [auth.user_id, auth.token]);

  const renderActivitadeProducts = (products: ProductProps[]) => {
    if (!products.length) {
      return null;
    }
    return products.map((item) => {
      return (
        <WrapperInnerCard
          key={item.productKey}
          noPadding
          noMargin
          backgroundColor="#F5F5F5"
        >
          <ProductActivatedCard {...item} />
        </WrapperInnerCard>
      );
    });
  };

  const renderedActivitadeProducts = renderActivitadeProducts(products);

  if (loading) {
    return (
      <ContainerCard noPadding elevation={2}>
        <div style={{ margin: "100px auto" }}>
          <Typography
            variant="h1"
            style={{ color: "#000", display: "flex", justifyContent: "center" }}
            align="center"
          >
            <Spinner size={80} />
          </Typography>
        </div>
      </ContainerCard>
    );
  }

  return (
    <ContainerCard noPadding elevation={2}>
      <HeaderCard backgroundColor={"#15997B"}>
        <Typography
          variant="body2"
          align="center"
          variantMapping={{
            h4: "h1",
          }}
          style={{
            fontWeight: "bold",
            color: "#fff",
          }}
        >
          Kaspersky / Minha Conta
        </Typography>
      </HeaderCard>
      <BodyCard>
        <BodyCardTitle variant="h1">
          Aqui você encontra o melhor serviço de segurança para os seus
          dipositivos: PC, celular e tablet.
        </BodyCardTitle>

        <BodyCardSubtitle>Para ativar a sua licença:</BodyCardSubtitle>
        <BodyCardSubtitle>
          1 - Acesse:{" "}
          <Link
            href="https://my.kaspersky.com"
            target="_blank"
            rel="noreferrer"
          >
            https://my.kaspersky.com
          </Link>
        </BodyCardSubtitle>
        <BodyCardSubtitle>
          2 - Faça login em sua conta Kaspersky ou registre-se.
        </BodyCardSubtitle>
        <BodyCardSubtitle>
          3 - Na aba Assinaturas, adicione o código do produto.
        </BodyCardSubtitle>
        <BodyCardSubtitle>
          4 - Após a instalação seu produto estará ativado! Aproveite toda
          segurança e tranquilidade de usar Kaspersky!
        </BodyCardSubtitle>

        {renderedActivitadeProducts ? (
          renderedActivitadeProducts
        ) : (
          <WrapperInnerCard noPadding noMargin backgroundColor="#F5F5F5">
            <WrapperNoProduct>
              <BodyCardSubtitle align="center">
                No momento você não possui nenhum produto ativo em nosso
                sistema.
              </BodyCardSubtitle>
            </WrapperNoProduct>
          </WrapperInnerCard>
        )}
      </BodyCard>
    </ContainerCard>
  );
}

export default MyAccount;
